import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingSocialButtons from './components/FloatingSocialButtons';
import ScrollToTop from './components/ScrollToTop';
import BottomNavbar from './components/BottomNavbar';

// Import des pages
import Accueil from './pages/Accueil';
import Mecanique from './pages/Mecanique';
import VenteAuto from './pages/VenteAuto';
import VehicleDetail from './pages/VehicleDetail';
import Blog from './pages/Blog';
// Tarifs temporairement désactivé
import Admin from './pages/Admin';
import ContactPage from './pages/ContactPage';
import OnboardingWizard from './pages/OnboardingWizard';
import Account from './pages/Account';
import ResetPassword from './pages/ResetPassword';

// Composant pour gérer l'affichage conditionnel
function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isOnboarding = location.pathname.startsWith('/inscription');
  const isAccount = location.pathname.startsWith('/mon-compte');

  return (
    <div className="App">
      {!isAdminPage && !isOnboarding && !isAccount && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/mecanique" element={<Mecanique />} />
          <Route path="/vente-auto" element={<VenteAuto />} />
          <Route path="/vente-auto/:id" element={<VehicleDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Blog />} />
          {/** Page Tarifs désactivée temporairement **/}
          <Route path="/admin" element={<Admin />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/inscription" element={<OnboardingWizard />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mon-compte" element={<Account />} />
        </Routes>
      </main>
      {!isAdminPage && !isOnboarding && !isAccount && <Footer />}
      {!isAdminPage && !isOnboarding && !isAccount && <FloatingSocialButtons />}
      {!isAdminPage && !isOnboarding && !isAccount && <BottomNavbar />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;